import { UadListingStatus } from '@aloft/toolkit-shared/lib/syntax/fnma/types';

export function getShouldApplyListToSale(listingStatus: UadListingStatus): boolean {
  return listingStatus === 'Active' || listingStatus === 'Contract';
}
